/* eslint-disable no-restricted-globals */ // TOOD: fix this
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import EditableLabel from 'react-inline-editing'

import { setModifyInvoice, modifyItemValue } from '../../../store/actions/modifyInvoice'
import styles from '../../Table/Table.module.scss'

/**
* @author zilahir
* @function InlineEdit
* */

const InlineEdit = props => {
	const { originalValue, keyValue, index } = props
	const [activeClass, setActiveClass] = useState(false)
	const [inActiveClass, setInactiveClass] = useState(false)
	const [isDifferent, setIsDifferent] = useState(false)
	const [newValue, setNewValue] = useState(null)
	const dispatch = useDispatch()
	function handleFocusOn() {
		setActiveClass(true)
	}

	function handleFocusOut(value, oValue, ind) {
		setInactiveClass(false)
		if (value !== oValue) {
			setIsDifferent(true)
			setNewValue(value)
			if (!isNaN(ind) && ind != null) {
				dispatch(modifyItemValue(keyValue, value, index))
			} else {
				dispatch(setModifyInvoice(keyValue, value))
			}
		} else {
			setIsDifferent(false)
			setNewValue(null)
		}
		return keyValue
	}
	return (
		<>
			<EditableLabel
				inputClassName={classnames(
					styles.textInput,
					activeClass ? styles.active : null,
				)}
				labelClassName={classnames(
					isDifferent ? styles.newValue : null,
					inActiveClass ? styles.inActive : null,
				)}
				text={newValue || originalValue}
				onFocus={() => handleFocusOn()}
				onFocusOut={v => handleFocusOut(v, originalValue, index)}
			/>
			{
				isDifferent
					? (
						<p className={styles.originalValue}>
							{originalValue}
						</p>
					)
					: null
			}
		</>
	)
}

InlineEdit.defaultProps = {
	index: null,
}

InlineEdit.propTypes = {
	index: PropTypes.number,
	keyValue: PropTypes.string.isRequired,
	originalValue: PropTypes.string.isRequired,
}

export default InlineEdit
